import {tr, txt} from '../i18n/idioma';
import {NotaDeAyuda} from './nota-de-ayuda';

const AYUDA_ZARPE = txt(
  'Fecha de zarpe (ETD) de la exportación en el seguimiento: la del Status o la que se editó en la app. Elige el primer y el último mes.',
  'Departure date (ETD) of the export in the tracking: from the Status or edited in the app. Choose the first and the last month.',
);
const AYUDA_LLEGADA = txt(
  'Fecha de llegada (ETA) de la exportación en el seguimiento: la del Status, la reserva o el rastreador de navieras, o la que se editó en la app.',
  'Arrival date (ETA) of the export in the tracking: from the Status, the booking or the carrier tracker, or edited in the app.',
);

// Ultimo dia de un mes "AAAA-MM".
const finDeMes = (mes: string) => {
  const [a, m] = mes.split('-').map(Number) as [number, number];
  return `${mes}-${String(new Date(Date.UTC(a, m, 0)).getUTCDate()).padStart(2, '0')}`;
};

// Filtro de zarpe (ETD) por mes, desde / hasta: en la direccion quedan
// etdDesde (dia 1 del mes) y etdHasta (ultimo dia del mes).
export function RangoDeZarpe({
  parametros,
  cambiar,
}: {
  parametros: URLSearchParams;
  cambiar: (clave: string, valor: string) => void;
}) {
  return (
    <>
      {(
        [
          ['etdDesde', tr('Mes de zarpe (ETD) desde', 'Departure month (ETD) from'), (m: string) => `${m}-01`],
          ['etdHasta', tr('Mes de zarpe (ETD) hasta', 'Departure month (ETD) to'), finDeMes],
        ] as const
      ).map(([clave, etiqueta, aFecha]) => (
        <label key={clave} className="flex flex-col gap-1 text-xs text-apagado">
          <span>
            {etiqueta}
            <NotaDeAyuda titulo={etiqueta} texto={AYUDA_ZARPE} dentroDeEtiqueta />
          </span>
          <input
            type="month"
            value={(parametros.get(clave) ?? '').slice(0, 7)}
            onChange={e => cambiar(clave, e.target.value ? aFecha(e.target.value) : '')}
            className="rounded-md border border-linea px-2 py-1 text-sm text-tinta"
          />
        </label>
      ))}
    </>
  );
}

// Filtro de llegada (ETA) desde / hasta, para las tablas con filtros en la
// direccion (parametros etaDesde y etaHasta).
export function RangoDeLlegada({
  parametros,
  cambiar,
}: {
  parametros: URLSearchParams;
  cambiar: (clave: string, valor: string) => void;
}) {
  return (
    <>
      {(
        [
          ['etaDesde', tr('Llegada (ETA) desde', 'Arrival (ETA) from')],
          ['etaHasta', tr('Llegada (ETA) hasta', 'Arrival (ETA) to')],
        ] as const
      ).map(([clave, etiqueta]) => (
        <label key={clave} className="flex flex-col gap-1 text-xs text-apagado">
          <span>
            {etiqueta}
            <NotaDeAyuda titulo={etiqueta} texto={AYUDA_LLEGADA} dentroDeEtiqueta />
          </span>
          <input
            type="date"
            value={parametros.get(clave) ?? ''}
            onChange={e => cambiar(clave, e.target.value)}
            className="rounded-md border border-linea px-2 py-1 text-sm text-tinta"
          />
        </label>
      ))}
    </>
  );
}
